import { BiteLogMaitredEvent } from './bite_log_maitred_event.js';

export function name(event: BiteLogMaitredEvent): string {
  switch (event) {
    case BiteLogMaitredEvent.OK:
      return 'ok';
    case BiteLogMaitredEvent.OrderValidateError:
      return 'order-validate-error';
    case BiteLogMaitredEvent.OrderSendToPosError:
      return 'order-send-to-pos-error';
    case BiteLogMaitredEvent.OrderCourierValidateError:
      return 'order-courier-validate-error';
    case BiteLogMaitredEvent.OrderSendToLoyaltyError:
      return 'order-send-to-loyalty-error';
    case BiteLogMaitredEvent.OrderSendToI9nsError:
      return 'order-send-to-i9ns-error';
    case BiteLogMaitredEvent.OrderValidated:
      return 'order-validated';
    case BiteLogMaitredEvent.OrderValidationSkipped:
      return 'order-validation-skipped';
    case BiteLogMaitredEvent.OrderValidationSuperseded:
      return 'order-validation-superseded';
    case BiteLogMaitredEvent.OrderValidationSkippedUnchanged:
      return 'order-validation-skipped-unchanged';
    case BiteLogMaitredEvent.OrderReceived:
      return 'order-received';
    case BiteLogMaitredEvent.OrderSentToPos:
      return 'order-sent-to-pos';
    case BiteLogMaitredEvent.OrderSentToLoyalty:
      return 'order-sent-to-loyalty';
    case BiteLogMaitredEvent.LateOrderReceived:
      return 'late-order-received';
    case BiteLogMaitredEvent.OrderSentToI9ns:
      return 'order-sent-to-i9ns';
    case BiteLogMaitredEvent.ScreenshotReceived:
      return 'screenshot-received';
    case BiteLogMaitredEvent.DeviceLogsReceived:
      return 'device-logs-received';
    case BiteLogMaitredEvent.OrderSendingSkipped:
      return 'order-sending-skipped';
    case BiteLogMaitredEvent.OrderSendToLoyaltySkipped:
      return 'order-send-to-loyalty-skipped';
    case BiteLogMaitredEvent.OrderVoidedOnLoyalty:
      return 'order-voided-on-loyalty';
    case BiteLogMaitredEvent.OrderVoidOnLoyaltyError:
      return 'order-void-on-loyalty-error';
    case BiteLogMaitredEvent.OrderVoidOnLoyaltySkipped:
      return 'order-void-on-loyalty-skipped';
    case BiteLogMaitredEvent.WebhookReceived:
      return 'webhook-received';
    case BiteLogMaitredEvent.Webhook86dItemsSuccessful:
      return 'webhook-86d-items-successful';
    case BiteLogMaitredEvent.Webhook86dItemsFailed:
      return 'webhook-86d-items-failed';
    case BiteLogMaitredEvent.WebhookMenuUpdateSuccessful:
      return 'webhook-menu-update-successful';
    case BiteLogMaitredEvent.WebhookMenuUpdateFailed:
      return 'webhook-menu-update-failed';
    case BiteLogMaitredEvent.TransactionCommitted:
      return 'transaction-committed';
    case BiteLogMaitredEvent.TransactionCommitError:
      return 'transaction-commit-error';
    case BiteLogMaitredEvent.TransactionRefundIssued:
      return 'transaction-refund-issued';
    case BiteLogMaitredEvent.TransactionRefundError:
      return 'transaction-refund-error';
    case BiteLogMaitredEvent.OrderValidatedOnLoyalty:
      return 'order-validated-on-loyalty';
    case BiteLogMaitredEvent.OrderValidationOnLoyaltySkipped:
      return 'order-validation-on-loyalty-skipped';
    case BiteLogMaitredEvent.OrderValidationOnLoyaltyError:
      return 'order-validation-on-loyalty-error';
    case BiteLogMaitredEvent.OrderValidatedOnOther:
      return 'order-validated-on-loyalty';
    case BiteLogMaitredEvent.OrderValidationOnOtherSkipped:
      return 'order-validation-on-other-error';
    case BiteLogMaitredEvent.OrderValidationOnOtherError:
      return 'order-validation-on-other-error';
    case BiteLogMaitredEvent.OrderCreatedOnPos:
      return 'order-created-on-pos';
    case BiteLogMaitredEvent.OrderCreatedOnPosError:
      return 'order-created-on-pos-error';
    case BiteLogMaitredEvent.OrderCreatedOnPosSkipped:
      return 'order-created-on-pos-skipped';
    case BiteLogMaitredEvent.OrderAddToCreateOrderQueue:
      return 'order-add-to-create-order-queue';
    case BiteLogMaitredEvent.OrderAddToCreateOrderQueueError:
      return 'order-add-to-create-order-queue-error';
    case BiteLogMaitredEvent.OrderGetCreateOrderQueueError:
      return 'order-get-create-order-queue-error';
    case BiteLogMaitredEvent.OrderCreatedOnLoyalty:
      return 'order-created-on-loyalty';
    case BiteLogMaitredEvent.OrderCreatedOnLoyaltyError:
      return 'order-created-on-loyalty-error';
    case BiteLogMaitredEvent.OrderCreatedOnLoyaltySkipped:
      return 'order-created-on-loyalty-skipped';
    case BiteLogMaitredEvent.OrderWaitTimeCreateOrderQueue:
      return 'order-wait-time-create-order-queue';
    case BiteLogMaitredEvent.OrderUpdatedOnPos:
      return 'order-updated-on-pos';
    case BiteLogMaitredEvent.OrderUpdateOnPosError:
      return 'order-update-on-pos-error';
    case BiteLogMaitredEvent.OrderUpdateOnPosSkipped:
      return 'order-update-on-pos-skipped';
    case BiteLogMaitredEvent.OrderAddToUpdateOrderOnPosQueue:
      return 'order-add-to-update-order-on-pos-queue';
    case BiteLogMaitredEvent.OrderAddToUpdateOrderOnPosQueueError:
      return 'order-add-to-update-order-on-pos-queue-error';
    case BiteLogMaitredEvent.OrderGetUpdateOrderOnPosQueueError:
      return 'order-get-update-order-on-pos-queue-error';
    case BiteLogMaitredEvent.OrderWaitTimeUpdateOrderOnPosOrderQueue:
      return 'order-wait-time-update-order-on-pos-queue';
    case BiteLogMaitredEvent.OrderPatchOnQsr:
      return 'order-patch-on-qsr';
    case BiteLogMaitredEvent.OrderPatchOnQsrError:
      return 'order-patch-on-qsr-error';
    case BiteLogMaitredEvent.GuestReceiptEmail:
      return 'order-receipt-email';
    case BiteLogMaitredEvent.GuestReceiptEmailError:
      return 'guest-receipt-email-error';
    case BiteLogMaitredEvent.GuestReceiptSms:
      return 'guest-receipt-sms-sent';
    case BiteLogMaitredEvent.GuestReceiptSmsError:
      return 'guest-receipt-sms-error';
    case BiteLogMaitredEvent.GuestMerge:
      return 'guest-merge';
    case BiteLogMaitredEvent.NotifierSendError:
      return 'notifier-send-error';
    case BiteLogMaitredEvent.LoyaltySignupSmsError:
      return 'loyalty-signup-sms-error';
    case BiteLogMaitredEvent.LoyaltySignupSms:
      return 'loyalty-signup-sms';
    case BiteLogMaitredEvent.LoyaltySignupInstantEnrollError:
      return 'loyalty-signup-instant-enroll-error';
    case BiteLogMaitredEvent.LoyaltySignupInstantEnroll:
      return 'loyalty-signup-instant-enroll';
    case BiteLogMaitredEvent.NotificationAddToQueue:
      return 'notification-add-to-queue';
    case BiteLogMaitredEvent.NotificationAddToQueueError:
      return 'notification-add-to-queue-error';
    case BiteLogMaitredEvent.OrderCreated:
      return 'order-created';
    case BiteLogMaitredEvent.OrderCreatedError:
      return 'order-created-error';
    case BiteLogMaitredEvent.IdempotentOrderCreated:
      return 'idempotent-order-created';
    case BiteLogMaitredEvent.IdempotentOrderReceived:
      return 'idempotent-order-received';
    case BiteLogMaitredEvent.OrderValidateTip:
      return 'order-validate-tip';
    case BiteLogMaitredEvent.OrderValidateTipError:
      return 'order-validate-tip-error';
    case BiteLogMaitredEvent.OrderValidateDonation:
      return 'order-validate-donation';
    case BiteLogMaitredEvent.OrderValidateDonationError:
      return 'order-validate-donation-error';
    case BiteLogMaitredEvent.OrderUpdated:
      return 'order-updated';
    case BiteLogMaitredEvent.OrderUpdatedError:
      return 'order-updated-error';
    case BiteLogMaitredEvent.FreeItemPromotionApplied:
      return 'free-item-promotion-applied';
    case BiteLogMaitredEvent.OrderCloned:
      return 'order-cloned';
    case BiteLogMaitredEvent.OrderClonedError:
      return 'order-cloned-error';
    case BiteLogMaitredEvent.OrderClosed:
      return 'order-closed';
    case BiteLogMaitredEvent.OrderClosedError:
      return 'order-closed-error';
    case BiteLogMaitredEvent.IdempotentOrderClosed:
      return 'idempotent-order-closed';
    case BiteLogMaitredEvent.OrderCancelled:
      return 'order-cancelled';
    case BiteLogMaitredEvent.OrderCancelledError:
      return 'order-cancelled-error';
    case BiteLogMaitredEvent.IdempotentOrderCancelled:
      return 'idempotent-order-cancelled';
    case BiteLogMaitredEvent.OrderRefunded:
      return 'order-refunded';
    case BiteLogMaitredEvent.OrderRefundError:
      return 'order-cancelled-error';
    case BiteLogMaitredEvent.IdempotentOrderRefunded:
      return 'idempotent-order-refunded';
    case BiteLogMaitredEvent.OrderAbandoned:
      return 'order-abandoned';
    case BiteLogMaitredEvent.OrderAbandonError:
      return 'order-abandon-error';
    case BiteLogMaitredEvent.OrderCouponAdd:
      return 'order-coupon-add';
    case BiteLogMaitredEvent.OrderCouponAddError:
      return 'order-coupon-add-error';
    case BiteLogMaitredEvent.OrderCouponRemove:
      return 'order-coupon-remove';
    case BiteLogMaitredEvent.OrderCouponRemoveError:
      return 'order-coupon-remove-error';
    case BiteLogMaitredEvent.OrderCompCardApply:
      return 'order-comp-card-apply';
    case BiteLogMaitredEvent.OrderCompCardApplyError:
      return 'order-comp-card-apply-error';
    case BiteLogMaitredEvent.OrderCompCardRemove:
      return 'order-comp-card-remove';
    case BiteLogMaitredEvent.OrderCompCardRemoveError:
      return 'order-comp-card-remove-error';
    case BiteLogMaitredEvent.OrderSentToCompCard:
      return 'order-sent-to-comp-card';
    case BiteLogMaitredEvent.OrderSendToCompCardError:
      return 'order-send-to-comp-card-error';
    case BiteLogMaitredEvent.OrderSendToCompCardSkipped:
      return 'order-send-to-comp-card-skipped';
    case BiteLogMaitredEvent.OrderVoidedOnCompCard:
      return 'order-voided-on-comp-card';
    case BiteLogMaitredEvent.OrderVoidOnCompCardError:
      return 'order-void-on-comp-card-error';
    case BiteLogMaitredEvent.OrderVoidOnCompCardSkipped:
      return 'order-void-on-comp-card-skipped';
    case BiteLogMaitredEvent.OrderLoyaltyAddUnappliedReward:
      return 'order-loyalty-add-unapplied-reward';
    case BiteLogMaitredEvent.OrderLoyaltyAddUnappliedRewardError:
      return 'order-loyalty-add-unapplied-reward-error';
    case BiteLogMaitredEvent.OrderLoyaltyAddReward:
      return 'order-loyalty-add-reward';
    case BiteLogMaitredEvent.OrderLoyaltyAddRewardError:
      return 'order-loyalty-add-reward-error';
    case BiteLogMaitredEvent.OrderLoyaltyGetAvailableRewards:
      return 'order-loyalty-get-available-rewards';
    case BiteLogMaitredEvent.OrderLoyaltyGetAvailableRewardsError:
      return 'order-loyalty-get-available-rewards-error';
    case BiteLogMaitredEvent.OrderLoyaltyGetAvailableRewardsNoOrder:
      return 'loyalty-get-available-rewards-no-order';
    case BiteLogMaitredEvent.OrderLoyaltyGetAvailableRewardsNoOrderError:
      return 'loyalty-get-available-rewards-no-order-error';
    case BiteLogMaitredEvent.OrderLoyaltyAuth:
      return 'order-loyalty-auth';
    case BiteLogMaitredEvent.OrderLoyaltyAuthError:
      return 'order-loyalty-auth-error';
    case BiteLogMaitredEvent.OrderLoyaltySignOut:
      return 'order-loyalty-sign-out';
    case BiteLogMaitredEvent.OrderLoyaltySignOutError:
      return 'order-loyalty-sign-out-error';
    case BiteLogMaitredEvent.OrderLoyaltyRemoveReward:
      return 'order-loyalty-remove-reward';
    case BiteLogMaitredEvent.OrderLoyaltyRemoveRewardError:
      return 'order-loyalty-remove-reward-error';
    case BiteLogMaitredEvent.OrderLoyaltyIdempotentRemoveReward:
      return 'order-loyalty-idempotent-remove-reward';
    case BiteLogMaitredEvent.OrderLoyaltyRedeemRewardCode:
      return 'order-loyalty-redeem-reward-code';
    case BiteLogMaitredEvent.OrderLoyaltyRedeemRewardCodeError:
      return 'order-loyalty-redeem-reward-code-error';
    case BiteLogMaitredEvent.OrderAddToSendOrderQueue:
      return 'order-add-to-send-order-queue';
    case BiteLogMaitredEvent.OrderAddToSendOrderQueueError:
      return 'order-add-to-send-order-queue-error';
    case BiteLogMaitredEvent.OrderGetSendOrderQueueError:
      return 'order-get-send-order-queue-error';
    case BiteLogMaitredEvent.OrderAddToValidateOrderQueue:
      return 'order-add-to-validate-order-queue';
    case BiteLogMaitredEvent.OrderAddToValidateOrderQueueError:
      return 'order-add-to-validate-order-queue-error';
    case BiteLogMaitredEvent.OrderGetValidateOrderQueueError:
      return 'order-get-validate-order-queue-error';
    case BiteLogMaitredEvent.PaymentFlashCreate:
      return 'payment-flash-create';
    case BiteLogMaitredEvent.PaymentFlashCreateError:
      return 'payment-flash-create-error';
    case BiteLogMaitredEvent.PaymentFlashCreateIdempotent:
      return 'payment-flash-create-idempotent';
    case BiteLogMaitredEvent.PaymentKioskCreate:
      return 'payment-kiosk-create';
    case BiteLogMaitredEvent.PaymentKioskCreateError:
      return 'payment-kiosk-create-error';
    case BiteLogMaitredEvent.PaymentKioskCreateIdempotent:
      return 'payment-kiosk-create-idempotent';
    case BiteLogMaitredEvent.PaymentKioskApiCreate:
      return 'payment-kiosk-api-create';
    case BiteLogMaitredEvent.PaymentKioskApiCreateError:
      return 'payment-kiosk-api-create-error';
    case BiteLogMaitredEvent.PaymentKioskPreReadCardQueue:
      return 'payment-kiosk-pre-read-card-queue';
    case BiteLogMaitredEvent.PaymentKioskPreReadCardQueueError:
      return 'payment-kiosk-pre-read-card-queue-error';
    case BiteLogMaitredEvent.PaymentKioskPreReadCard:
      return 'payment-kiosk-pre-read-card';
    case BiteLogMaitredEvent.PaymentKioskPreReadCardError:
      return 'payment-kiosk-pre-read-card-error';
    case BiteLogMaitredEvent.PaymentKioskApiCreateIdempotent:
      return 'payment-kiosk-api-create-idempotent';
    case BiteLogMaitredEvent.PaymentKioskApiRecovery:
      return 'payment-kiosk-api-recovery';
    case BiteLogMaitredEvent.PaymentKioskApiRecoveryError:
      return 'payment-kiosk-api-recovery-error';
    case BiteLogMaitredEvent.PaymentKioskApiCancel:
      return 'payment-kiosk-cancel';
    case BiteLogMaitredEvent.PaymentKioskApiCancelError:
      return 'payment-kiosk-cancel-error';
    case BiteLogMaitredEvent.PaymentStoredValueInquire:
      return 'payment-stored-value-inquire';
    case BiteLogMaitredEvent.PaymentStoredValueInquireError:
      return 'payment-stored-value-inquire-error';
    case BiteLogMaitredEvent.PaymentStoredValueCreate:
      return 'payment-stored-value-create';
    case BiteLogMaitredEvent.PaymentStoredValueCreateError:
      return 'payment-stored-value-create-error';
    case BiteLogMaitredEvent.PaymentStoredValueCreateIdempotent:
      return 'payment-stored-value-create-idempotent';
    case BiteLogMaitredEvent.PaymentGetStoredValueCreateQueueError:
      return 'payment-get-stored-value-create-queue-error';
    case BiteLogMaitredEvent.PaymentStoredValueBalanceLookup:
      return 'payment-stored-value-balance-lookup';
    case BiteLogMaitredEvent.PaymentStoredValueBalanceLookupError:
      return 'payment-stored-value-balance-lookup-error';
    case BiteLogMaitredEvent.PaymentRefund:
      return 'payment-refund';
    case BiteLogMaitredEvent.PaymentRefundError:
      return 'payment-refund-error';
    case BiteLogMaitredEvent.PaymentRefundIdempotent:
      return 'payment-refund-idempotent';
    case BiteLogMaitredEvent.PaymentGetRefundQueueError:
      return 'payment-get-refund-queue-error';
    case BiteLogMaitredEvent.PaymentAddToRefundQueue:
      return 'payment-add-to-refund-queue';
    case BiteLogMaitredEvent.PaymentRefundAddToRefundQueueError:
      return 'payment-refund-add-to-refund-queue-error';
    case BiteLogMaitredEvent.PaymentGetEcommQueueError:
      return 'payment-get-ecomm-queue-error';
    case BiteLogMaitredEvent.PaymentAddToEcommQueue:
      return 'payment-add-to-ecomm-queue';
    case BiteLogMaitredEvent.PaymentAddToEcommQueueError:
      return 'payment-add-to-ecomm-queue-error';
    case BiteLogMaitredEvent.PaymentGetKioskApiQueueError:
      return 'payment-get-kiosk-api-queue-error';
    case BiteLogMaitredEvent.PaymentAddToKioskApiQueue:
      return 'payment-add-to-kiosk-api-queue';
    case BiteLogMaitredEvent.PaymentAddToKioskApiQueueError:
      return 'payment-add-to-kiosk-api-queue-error';
    case BiteLogMaitredEvent.PaymentStripeDisbursementAddToQueue:
      return 'payment-stripe-disbursement-add-to-queue';
    case BiteLogMaitredEvent.PaymentStripeDisbursementAddToQueueError:
      return 'payment-stripe-disbursement-add-to-queue-error';
    case BiteLogMaitredEvent.PaymentStripeDisbursementError:
      return 'payment-stripe-disbursement-error';
    case BiteLogMaitredEvent.PaymentStripeDisbursementReversalAddToQueue:
      return 'payment-stripe-disbursement-reversal-add-to-queue';
    case BiteLogMaitredEvent.PaymentStripeDisbursementReversalAddToQueueError:
      return 'payment-stripe-disbursement-reversal-add-to-queue-error';
    case BiteLogMaitredEvent.PaymentStripeDisbursementReversalError:
      return 'payment-stripe-disbursement-reversal-error';
    case BiteLogMaitredEvent.MenuFetch:
      return 'menu-fetch';
    case BiteLogMaitredEvent.MenuFetchError:
      return 'menu-fetch-error';
    case BiteLogMaitredEvent.OrderWaitTimeSendOrderQueue:
      return 'order-wait-time-send-order-queue';
    case BiteLogMaitredEvent.OrderWaitTimeValidateOrderQueue:
      return 'order-wait-time-validate-order-queue';
    case BiteLogMaitredEvent.OrderPosSendAttemptDuration:
      return 'order-send-attempt-duration';
    case BiteLogMaitredEvent.OrderClientSendDuration:
      return 'order-client-send-duration';
    case BiteLogMaitredEvent.MenuSyncDuration:
      return 'menu-sync-duration';
    case BiteLogMaitredEvent.MenuSyncWaitTimeQuicksandQueue:
      return 'menu-sync-wait-time-quicksand-queue';
    case BiteLogMaitredEvent.MenuSyncDurationAndWaitTime:
      return 'menu-sync-duration-and-wait-time';
    case BiteLogMaitredEvent.MenuSyncError:
      return 'menu-sync-error';
    case BiteLogMaitredEvent.QueueJobCompleted:
      return 'queue-job-completed';
    case BiteLogMaitredEvent.QueueJobStalled:
      return 'queue-job-stalled';
    case BiteLogMaitredEvent.QueueJobFailed:
      return 'queue-job-failure';
    case BiteLogMaitredEvent.QueueJobRequeued:
      return 'queue-job-requeued';
    case BiteLogMaitredEvent.QueueWaitingCountOk:
      return 'queue-waiting-count-ok';
    case BiteLogMaitredEvent.QueueWaitingCountError:
      return 'queue-waiting-count-error';
    case BiteLogMaitredEvent.ReportSend:
      return 'report-send';
    case BiteLogMaitredEvent.ReportSendError:
      return 'report-send-error';
    case BiteLogMaitredEvent.WebhookSend:
      return 'webhook-send';
    case BiteLogMaitredEvent.WebhookSendError:
      return 'webhook-send-error';
    case BiteLogMaitredEvent.SmsNotifierSend:
      return 'sms-notifier-send';
    case BiteLogMaitredEvent.SmsNotifierSendError:
      return 'sms-notifier-send-error';
    case BiteLogMaitredEvent.SmsNotifierSendErrorLight:
      return 'sms-notifier-send-error-light';
    case BiteLogMaitredEvent.KioskPaymentTerminalStatusCheck:
      return 'kiosk-payment-terminal-get-status';
    case BiteLogMaitredEvent.KioskPaymentTerminalStatusCheckError:
      return 'kiosk-payment-terminal-get-status-error';
    case BiteLogMaitredEvent.KioskPaymentTerminalStoppedDuringPayment:
      return 'kiosk-payment-terminal-stopped-during-payment';
    case BiteLogMaitredEvent.KioskPaymentTerminalStoppedDuringPaymentError:
      return 'kiosk-payment-terminal-stopped-during-payment-error';
    case BiteLogMaitredEvent.KioskPaymentTerminalWakeUp:
      return 'kiosk-payment-terminal-wake-up';
    case BiteLogMaitredEvent.KioskPaymentTerminalWakeUpError:
      return 'kiosk-payment-terminal-wake-up-error';
    case BiteLogMaitredEvent.KioskPaymentTerminalModelCheckError:
      return 'kiosk-payment-terminal-model-check-error';
    case BiteLogMaitredEvent.ExpoPrintAuthError:
      return 'expo-print-auth-error';
    case BiteLogMaitredEvent.PaymentWaitTimeKioskApiPaymentQueue:
      return 'payment-wait-time-kiosk-api-payment-queue';
    case BiteLogMaitredEvent.FulfillmentPayloadFetchSuccess:
      return 'fulfillment-payload-fetch-success';
    case BiteLogMaitredEvent.FulfillmentPayloadFetchError:
      return 'fulfillment-payload-fetch-error';
    case BiteLogMaitredEvent.FulfillmentPayloadSendAttemptSuccess:
      return 'fulfillment-payload-send-attempt-success';
    case BiteLogMaitredEvent.FulfillmentPayloadSendAttemptError:
      return 'fulfillment-payload-send-attempt-error';
    case BiteLogMaitredEvent.PaymentNativeResponseCorrection:
      return 'payment-native-response-correction';
    case BiteLogMaitredEvent.PaymentNativeResponseException:
      return 'payment-native-response-exception';
    case BiteLogMaitredEvent.PaymentNativeRefundRequested:
      return 'payment-native-refund-requested';
    case BiteLogMaitredEvent.OrderSendToFulfillmentError:
      return 'order-send-to-fulfillment-error';
    case BiteLogMaitredEvent.OrderSendToFulfillmentSkipped:
      return 'order-send-to-fulfillment-skipped';
    case BiteLogMaitredEvent.OrderSentToFulfillment:
      return 'order-sent-to-fulfillment';
    case BiteLogMaitredEvent.OrderSendToMarketingError:
      return 'order-send-to-marketing-error';
    case BiteLogMaitredEvent.OrderSendToMarketingSkipped:
      return 'order-send-to-marketing-skipped';
    case BiteLogMaitredEvent.OrderSentToMarketing:
      return 'order-sent-to-marketing';
    case BiteLogMaitredEvent.OrderRedirectedToSurvey:
      return 'order-redirected-to-survey';
    case BiteLogMaitredEvent.OrderRedirectToSurveyError:
      return 'order-redirect-to-survey-error';
    case BiteLogMaitredEvent.OrderFetchGuestHistory:
      return 'order-fetch-guest-history';
    case BiteLogMaitredEvent.OrderFetchGuestHistoryError:
      return 'order-fetch-guest-history-error';
    case BiteLogMaitredEvent.OrderFetchGuestHistoryNoGuestFound:
      return 'order-fetch-guest-history-no-guest-found';
    case BiteLogMaitredEvent.OrderFetchGuestHistoryLoyalty:
      return 'order-fetch-guest-history-loyalty';
    case BiteLogMaitredEvent.OrderFetchGuestHistoryLoyaltyError:
      return 'order-fetch-guest-history-loyalty-error';
    case BiteLogMaitredEvent.OrderFetchGuestHistoryMatchingError:
      return 'order-fetch-guest-history-matching-error';
    case BiteLogMaitredEvent.MenuCacheGetMenuComponentsError:
      return 'menu-cache-get-menu-components-error';
    case BiteLogMaitredEvent.MenuCachePutMenuComponentsError:
      return 'menu-cache-put-menu-components-error';
    case BiteLogMaitredEvent.MenuCachePutMenuTimestampError:
      return 'menu-cache-put-menu-timestamp-error';
    case BiteLogMaitredEvent.MenuCachePutMenuLastUpdatedTimestampError:
      return 'menu-cache-put-menu-last-updated-timestamp-error';
    case BiteLogMaitredEvent.MenuCacheAssembleAndStoreMenuComponentsError:
      return 'menu-cache-assemble-and-store-menu-components-error';
    case BiteLogMaitredEvent.MenuCacheAssembleAndStoreMenuComponents:
      return 'menu-cache-assemble-and-store-menu-components';
    case BiteLogMaitredEvent.MenuCacheJobBuildError:
      return 'menu-cache-job-build-error';
    case BiteLogMaitredEvent.MenuCacheJobAssembleAndStoreMenuComponentsError:
      return 'menu-cache-job-assemble-and-store-menu-components-error';
    case BiteLogMaitredEvent.MenuCacheJobGetMenuLastUpdatedTimestampError:
      return 'menu-cache-job-get-menu-last-updated-timestamp-error';
    case BiteLogMaitredEvent.MenuCacheJobCacheOutdatedError:
      return 'menu-cache-job-cache-outdated-error';
    case BiteLogMaitredEvent.MenuCacheJobLocationNotFoundError:
      return 'menu-cache-job-location-not-found-error';
    case BiteLogMaitredEvent.MenuCacheJobLocationCannotUseCacheWarning:
      return 'menu-cache-job-location-cannot-use-cache-warning';
    case BiteLogMaitredEvent.MenuCacheGzipCompressDuration:
      return 'menu-cache-gzip-compress-duration';
    case BiteLogMaitredEvent.MenuCacheGzipDecompressDuration:
      return 'menu-cache-gzip-decompress-duration';
    case BiteLogMaitredEvent.WebhookThirdPartyOrderAccepted:
      return 'webhook-third-party-order-accepted';
    case BiteLogMaitredEvent.WebhookThirdPartyOrderRejected:
      return 'webhook-third-party-order-rejected';
    case BiteLogMaitredEvent.ThirdPartyOrderSendError:
      return 'third-party-order-send-error';
    case BiteLogMaitredEvent.ThirdPartyOrderWaitTimeSendOrderQueue:
      return 'third-party-order-wait-time-send-order-queue';
    case BiteLogMaitredEvent.ThirdPartyOrderSendAttemptDuration:
      return 'third-party-order-send-attempt-duration';
    case BiteLogMaitredEvent.ThirdPartyOrderSendToFulfillmentError:
      return 'third-party-order-send-to-fulfillment-error';
    case BiteLogMaitredEvent.ThirdPartyOrderSendToFulfillmentSkipped:
      return 'third-party-order-send-to-fulfillment-skipped';
    case BiteLogMaitredEvent.ThirdPartyOrderSentToFulfillment:
      return 'third-party-order-sent-to-fulfillment';
    case BiteLogMaitredEvent.ValidateIntegrationCredentialsError:
      return 'validate-integration-credentials-error';
    case BiteLogMaitredEvent.KorAlertSubscribed:
      return 'kor-alert-subscribed';
    case BiteLogMaitredEvent.KorAlertUnsubscribed:
      return 'kor-alert-unsubscribed';
    case BiteLogMaitredEvent.OfflineModeOrderProcessedByBackendSuccess:
      return 'offline-mode-order-processed-by-backend-success';
    case BiteLogMaitredEvent.OfflineModeOrderProcessedByBackendError:
      return 'offline-mode-order-processed-by-backend-error';
  }
}
